import React from "react";
import { ITypography } from "../../types";
import { BaseButtonProps } from "../Button/types";

export type TAlertColor = "heads-up" | "grey" | "error" | "success" | "warning";

type AlertBaseProps = {
    action?: Pick<BaseButtonProps, "loading" | "onClick" | "trackName" | "trackData"> & {
        title: string;
    };
    href?: string;
    color: TAlertColor;
    layout: "compact" | "default";
    onClose?: () => void;
    onCloseTrackName?: string;
    supportingText?: string;
    text: React.ReactNode;
    icon?: React.ReactNode;
    textTypographyVariant?: keyof ITypography;
};

export type TAlertBadgeGroupProps = AlertBaseProps & {
    badgeText: string;
    type: "badge-group";
};

export type TAlertTextProps = AlertBaseProps & {
    type: "text";
};

export type TAlertProps = TAlertBadgeGroupProps | TAlertTextProps;
